import { Component } from 'react';

class More extends Component {
  render() {
    return <div>More</div>;
  }
}

export default More;
